Drupal.behaviors.lazyAdsBehaviour = {
  attach: function (context, settings) {
    // Your code here, with 'context' to target specific parts of the DOM
    let lazy_ads_placeholder = once("lazyAdLoader", ".lazyad", context);

    let lazyLoadAdWithDelay = (ad_item, i) => {
      /* ************** Generate ad scripts ******************** */
      setTimeout(() => {
        let adScriptElement = document.createElement("script");
        adScriptElement.type = "text/javascript";
        let lazyad_id = ad_item.getAttribute("data-lazyadf");
        adScriptElement.setAttribute(
          "data-adfscript",
          "adx.adform.net/adx/?mid=" + lazyad_id
        );

        //ad_item.innerHTML = "";
        ad_item.insertAdjacentElement("afterbegin", adScriptElement);
      }, 300 * i);
    };

    let lazyLoadAdWithoutDelay = (ad_item) => {
      /* ************** Generate ad scripts ******************** */
      let adScriptElement = document.createElement("script");
      adScriptElement.type = "text/javascript";
      let lazyad_id = ad_item.getAttribute("data-lazyadf");
      adScriptElement.setAttribute(
        "data-adfscript",
        "adx.adform.net/adx/?mid=" + lazyad_id
      );

      //ad_item.innerHTML = "";
      ad_item.insertAdjacentElement("afterbegin", adScriptElement);
    };

    lazy_ads_placeholder.forEach((ad_placeholder_item, index) => {
      if (index <= 8) {
        lazyLoadAdWithoutDelay(ad_placeholder_item);
      } else {
        lazyLoadAdWithDelay(ad_placeholder_item, index);
      }
      //lazyLoadAdWithDelay(ad_placeholder_item, index);
    });
  },
};
